export default __webpack_public_path__ + "static/media/equipment.d15adf40.svg";